<div class="container" *ngIf="productObject">
  <div class="row my-5 pt-4 pt-sm-0 justify-content-center">
    <div class="col-12">
      <div class="card shadow rounded border-0">
        <div class="card-body">
          <div class="row align-items-center pb-5">
            <!-- Product Img -->
            <div class="col-md-5 d-flex flex-column justify-content-center" *ngIf="productObject.ReservationProductExtraInfo.image">
              <img [src]="productObject.ReservationProductExtraInfo.image" class="img-fluid rounded" alt="product" />
            </div>

            <!-- Product Info -->
            <div class="col-md-7 mt-4 mt-sm-0 pt-2 pt-sm-0">
              <div class="section-title ms-md-4">
                <h4 class="title">{{ productObject["productName"] }}</h4>

                <div class="mt-4 py-2">
                  <span class="h5">{{ "Buyer.Seller" | translate }} :</span>
                  <a target="_blank" routerLink="/{{ businessObject?.name }}" class="text-muted fs-5 name ms-2">
                    {{ businessObject?.name }}</a>
                </div>

                <h5 class="mt-4 pt-2">{{ "Buyer.Overview" | translate }} :</h5>
                <p class="text-muted">
                  {{getNewProductValueByFieldName('description','ProductExtraInfos')}}
                </p>

                <div class="row align-items-baseline shop-list align-items-center mt-4 py-2">
                  <h6 class="mb-0" *ngIf="maxQuantity > 0">
                    {{ "Buyer.Quantity" | translate }} :
                  </h6>
                  <div class="col-sm-12 col-md-4 " *ngIf="parsedTickets.length > 0">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label style="font-weight:bold ;">{{ "Buyer.Choose_Booking" | translate }} : <span class="text-danger">*</span>
                      </mat-label>
                      <select matNativeControl (change)="onTicketChange($event)" class="form-control mt-2"
                        [formControl]="ticketForm" style="line-height: 23px!important;appearance:auto">
                        <option *ngFor="let ticket of parsedTickets" [value]="ticket.id">
                          {{ ticket.name }}
                        </option>
                      </select>
                    </mat-form-field>
                  </div>
                  <div class="col-md-4 col-sm-12 ">
                    <h6 class="mb-2 text-center">{{ 'Buyer.Quantity' | translate }}</h6>
                    <div style="transform: scale(.8);" class="d-flex mx-0 justify-content-center pt-md-3 pt-lg-0" >
                      <button class="col-4 btn btn-icon btn-soft-primary minus"
                        (click)="quantityDownChange($event, ticketSelected.name, ticketSelected.price, ticketSelected.id , ticketSelected.maxQuantityPerSale, 'prev')"
                        type="button" onclick="this.nextElementSibling.stepDown()">
                        -
                      </button>
                      <input type="number" min="0" max="{{ticketSelected?.maxQuantityPerSale}}" #inputVal  value="0" readonly
                        class="col-4 px-0 form-number-control text-center" />
                      <button class="col-4 btn btn-icon btn-soft-primary plus"
                        (click)="quantityUpChange($event, ticketSelected.name, ticketSelected.price, ticketSelected.id, ticketSelected.maxQuantityPerSale, 'next')"
                        type="button" onclick="this.previousElementSibling.stepUp()">
                        +
                      </button>
                    </div>
                  </div>
                  <div class="col-sm-12 col-md-4 text-center">
                    <h6  id="ticketPrice">{{ 'Buyer.Price' | translate }}</h6>
                    <h6 class="text-muted mt-3 pt-md-3 pt-lg-0">
                      {{
                      basePrice(ticketSelected?.price,getNewProductValueByFieldName('currency','ProductExtraInfos')).toFixed(2)
                      }}
                      {{
                      getNewProductValueByFieldName(
                      "currency",
                      "ProductExtraInfos"
                      )
                      }}
                    </h6>
                  </div>
                </div>
                  <p *ngIf="ticketSelected?.quanity <= 0" class="soldOut">
                    {{ "Buyer.SoldOut" | translate }}
                  </p>
                <div class="row mt-4 pt-2">
                  <div class="col-md-6 mb-3">
                    <span class="fs-5">{{ "Buyer.Total" | translate }} :</span>
                    <span class="text-primary fs-4 ms-2">
                      {{ subtotal.toFixed(2) }}
                      {{
                      getNewProductValueByFieldName(
                      "currency",
                      "ProductExtraInfos"
                      )
                      }}
                    </span>
                  </div>
                  <div class="col-md-6 mb-3">
                    <div class="text-end row mx-0">
                      <button class="btn btn-primary" type="button" [disabled]="subtotal <= 0"
                        (click)="proceedToPayment()">
                        {{ "Buyer.Next" | translate }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <app-event-terms-section [eventTerms]="eventTermsObject"></app-event-terms-section>
    </div>
  </div>
</div>
